/**
 * Met les heures, minutes etc à 0 ou les minutes etc à 59
 */
export function dateToUTCCompare(timestamp: number, end: boolean = false): number {
    const d = new Date(timestamp);
    const y   = d.getFullYear();
    const m   = d.getMonth();
    const day = d.getDate();

    return end
        ? new Date(Date.UTC(y, m, day, 23, 59, 59, 999)).getTime()
        : new Date(Date.UTC(y, m, day, 0,  0,  0,   0)).getTime();
}